import request from "../Config/axios";
// -----------------------------------------------------------
export const GetById_Price_Api = async (id) => {
    const { data } = await request.get(
        `/Price/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Price_Api = async (params) => {
    const { data } = await request.post(
        `/Price/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Price_Api = async (params) => {
    const { data } = await request.post(
        `/Price/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Paging_Price_Api = async (params) => {
    const { data } = await request.post(
        `/Price/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Price_Api = async (id) => {
    const { data } = await request.delete(
        `/Price/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
